import styled from '@emotion/styled'
import {
    AppBar,
    BottomNavigation,
    Button,
    MenuItem,
    MenuList,
} from '@mui/material'
import { Link, NavLink } from 'react-router-dom'
import { getPxAsRem } from 'shared/utils'

export const StyledNav = styled.nav`
    width: ${getPxAsRem(256)};
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.palette.primary.dark};
    color: ${({ theme }) => theme.palette.greyscale.white};
    overflow-y: auto;
    padding: ${getPxAsRem(8, 8, 16)};
`

export const StyledLogoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${getPxAsRem(8)};

    a {
        color: ${({ theme }) => theme.palette.greyscale.white};
    }
`

export const LogoutContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;

    a {
        color: ${({ theme }) => theme.palette.greyscale.white};
    }
`

export const AvatarContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPxAsRem(8)};
    padding: 0 ${getPxAsRem(8)};
`

export const StyledMenuList = styled(MenuList)`
    margin-top: ${getPxAsRem(16)};
`

export const StyledMenuItem = styled(MenuItem)`
    border-radius: 0.5rem;
    padding: 0;

    :has(a.active) {
        background-color: ${({ theme }) => theme.palette.primary.main};
    }
    &.Mui-focusVisible:has(a.active) {
        background-color: ${({ theme }) => theme.palette.other.focus_dark};
    }
`

export const StyledNavLink = styled(NavLink)`
    color: ${({ theme }) => theme.palette.greyscale.white};
    text-decoration: none;
    display: flex;
    width: 100%;
    padding: ${getPxAsRem(12, 16)};

    svg {
        margin-right: 2rem;
    }
`

export const MobileLogoContainer = styled(Link)`
    margin-top: ${getPxAsRem(2)};
    margin-left: ${getPxAsRem(2)};
    margin-right: ${getPxAsRem(2)};
    padding-top: ${getPxAsRem(4)};
    padding-right: ${getPxAsRem(2)};
    padding-left: ${getPxAsRem(2)};

    :focus {
        margin: 0;
        border: 2px solid ${({ theme }) => theme.palette.primary.light};
        border-radius: 8px;
        outline: none;
    }
`
export const StyledAppBar = styled(AppBar)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${getPxAsRem(8, 16)};
    background-color: ${({ theme }) => theme.palette.primary.dark};
    color: ${({ theme }) => theme.palette.greyscale.white};
    box-shadow: none;

    .MuiListItem-root {
        height: ${getPxAsRem(40)};
        width: ${getPxAsRem(40)};
    }

    .MuiListItemIcon-root {
        color: ${({ theme }) => theme.palette.greyscale.white};
        min-width: 0;
    }
    .MuiListItemIcon-root.active {
        color: ${({ theme }) => theme.palette.primary.light};
    }

    .MuiListItemButton-root {
        background-color: ${({ theme }) => theme.palette.primary.dark};
        border-radius: 50%;
        padding: ${getPxAsRem(8)};
        height: ${getPxAsRem(40)};
        width: ${getPxAsRem(40)};
    }

    .MuiListItemButton-root.Mui-focusVisible {
        background-color: ${({ theme }) => theme.palette.primary.light};
        color: ${({ theme }) => theme.palette.primary.main};

        .MuiListItemIcon-root {
            color: ${({ theme }) => theme.palette.primary.main};
        }
    }

    .MuiTextField-root {
        margin: 0px;
    }
`
export const StyledBottomNavigation = styled(BottomNavigation)`
    background-color: ${({ theme }) => theme.palette.primary.dark};
    color: ${({ theme }) => theme.palette.greyscale.white};
    box-shadow: none;

    .MuiBottomNavigationAction-root {
        color: ${({ theme }) => theme.palette.greyscale.white};
    }
    .MuiBottomNavigationAction-root.Mui-selected {
        color: ${({ theme }) => theme.palette.primary.light};
    }

    .Mui-focusVisible {
        background-color: ${({ theme }) => theme.palette.primary.light};
        color: ${({ theme }) => theme.palette.primary.main};

        .MuiBottomNavigationAction-root {
            color: ${({ theme }) => theme.palette.primary.main};
        }
    }
`

export const SkipNavButton = styled(Button, {
    shouldForwardProp: (name) => name !== 'isMobile',
})<{ isMobile: boolean }>`
    position: absolute;
    top: -40px;
    left: 0;
    overflow: hidden;
    z-index: 1000;
    background-color: ${({ theme }) => theme.palette.primary.main};

    &:focus {
        top: ${({ isMobile }) => getPxAsRem(isMobile ? 72 : 8)};
        left: ${({ isMobile }) => getPxAsRem(isMobile ? 8 : 64)};
    }
`
